import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { dataActionCreators, Sale } from '../../store/Data';
import { Button, Text } from '@fluentui/react-components';
import { Dismiss24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';

export const SalesQuickView = () => {
    const salesQuickView = useSelector<ApplicationState, Sale | null>((state: ApplicationState) => state.data.salesQuickView);
    const dispatch = useDispatch();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const styles = useQuickViewStyles();

    if (salesQuickView) {
        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{"Sale : " + (salesQuickView.date ? new Date(salesQuickView.date).toLocaleDateString() : "-")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                    <Text truncate>{salesQuickView.sellid}</Text>
                    </>
                }
                {salesQuickView.description && <>
                    <h2>Description</h2>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{salesQuickView.description}</pre>
                </>}
            </div>
        );
    }
    return null;
};